export enum ButtonTypeEnum {
  default = 'default',
  primary = 'primary',
  warning = 'warning',
  danger = 'danger',
  link = 'link',
}
